import type { ReactNode } from 'react';
import { GlobalReducerState } from './Global.types';

type GlobalAction =
  | { type: 'SET_PATIENT'; payload: Partial<import('./Global.types').PatientInfo> }
  | { type: 'TOGGLE_SIDEBAR' }
  | { type: 'SET_SUCCESS_MODAL'; payload: { title: string } }
  | { type: 'SET_INFO_MODAL'; payload: { title: string; message?: string; html?: ReactNode } }
  | { type: 'SET_CONFIRM_MODAL'; payload: { title: string; message: string; handleConfirm: () => void; handleCancel?: () => void } }
  | { type: 'SET_ERROR_MODAL'; payload: { title?: string; message?: string } }
  | { type: 'CLOSE_SUCCESS_MODAL' }
  | { type: 'CLEAN_SUCCESS_MODAL' }
  | { type: 'CLOSE_INFO_MODAL' }
  | { type: 'CLEAN_INFO_MODAL' }
  | { type: 'CLOSE_CONFIRM_MODAL' }
  | { type: 'CLEAN_CONFIRM_MODAL' }
  | { type: 'CLOSE_ERROR_MODAL' }
  | { type: 'CLEAN_ERROR_MODAL' }
  | { type: 'SET_TOAST'; payload: { type: 'success' | 'error'; message: string } }
  | { type: 'CLOSE_TOAST' }
  | { type: 'CLEAN_TOAST' };

export const globalReducer = (state: GlobalReducerState, action: GlobalAction): GlobalReducerState => {
  switch (action.type) {
    case 'SET_PATIENT':
      return {
        ...state,
        patient: { ...state.patient, ...action.payload },
      };

    case 'TOGGLE_SIDEBAR':
      return { ...state, sidebarOpen: !state.sidebarOpen };

    case 'SET_SUCCESS_MODAL':
      return { ...state, successModal: { show: true, title: action.payload.title } };

    case 'SET_INFO_MODAL':
      return { ...state, infoModal: { show: true, title: action.payload.title, message: action.payload.message || '', html: action.payload.html || null } };

    case 'SET_CONFIRM_MODAL':
      return {
        ...state,
        confirmModal: {
          show: true,
          title: action.payload.title,
          message: action.payload.message,
          handleConfirm: action.payload.handleConfirm,
          handleCancel: action.payload.handleCancel || (() => {}),
        },
      };

    case 'SET_ERROR_MODAL':
      return { ...state, errorModal: { show: true, title: action.payload.title || 'Error', message: action.payload.message || 'An error occurred' } };

    case 'CLOSE_SUCCESS_MODAL':
      return { ...state, successModal: { ...state.successModal, show: false } };

    case 'CLEAN_SUCCESS_MODAL':
      return { ...state, successModal: { show: false, title: '' } };

    case 'CLOSE_INFO_MODAL':
      return { ...state, infoModal: { ...state.infoModal, show: false } };

    case 'CLEAN_INFO_MODAL':
      return { ...state, infoModal: { show: false, title: '', message: '', html: null } };

    case 'CLOSE_CONFIRM_MODAL':
      return { ...state, confirmModal: { ...state.confirmModal, show: false } };

    case 'CLEAN_CONFIRM_MODAL':
      return { ...state, confirmModal: { show: false, title: '', message: '', handleConfirm: () => {}, handleCancel: () => {} } };

    case 'CLOSE_ERROR_MODAL':
      return { ...state, errorModal: { ...state.errorModal, show: false } };

    case 'CLEAN_ERROR_MODAL':
      return { ...state, errorModal: { show: false, title: '', message: '' } };

    case 'SET_TOAST':
      return { ...state, toast: { show: true, type: action.payload.type, message: action.payload.message } };

    case 'CLOSE_TOAST':
      return { ...state, toast: { ...state.toast, show: false } };

    case 'CLEAN_TOAST':
      return { ...state, toast: { show: false, type: 'success', message: '' } };

    default:
      return state;
  }
};
